import React from 'react';
import PropTypes from 'prop-types';

import AccountCard from '../../../../../../../../services/cards/components/AccountCard';
import useAccountCardConfigure from '../../../../../../../../services/cards/views/AccountCardConfigurator/useAccountCardConfigure';
import Spinner from '../../../../../../../../components/global/Spinner';

const propTypes = {
  accountCardId: PropTypes.string,
  photoOpacity: PropTypes.number,
};
const AccountCardEditor = ({ accountCardId, photoOpacity }) => {
  const { accountCard, loadingAccountCard, onElementConfigurationChange } =
    useAccountCardConfigure({
      accountCardId,
      prioritizeAccountCardId: true,
    });

  if (loadingAccountCard) {
    return (
      <div className="w-100 h-100 d-flex align-items-center justify-content-center">
        <Spinner />
      </div>
    );
  }

  return (
    <div className="w-100" style={{ opacity: photoOpacity }}>
      <AccountCard
        key={accountCard?.id}
        onElementConfigurationChange={onElementConfigurationChange}
        accountCard={accountCard}
        animatable={false}
        allowPhotoChange={false}
        viewOnly={false}
        disablePhotoWatermarkOverlay
      />
    </div>
  );
};

AccountCardEditor.propTypes = propTypes;

export default AccountCardEditor;
